/**
 * @fileoverview Login page.
 * @description Composes the auth page shell with the login card. Route-level only — the actual
 * form, validation, and submit logic live in LoginForm/useLogin.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { AuthCard } from '@/features/auth'
import AuthLayout from '@/shared/components/layouts/AuthLayout'

/**
 * @component
 */
function LoginPage() {
  return (
    <AuthLayout>
      <AuthCard />
    </AuthLayout>
  )
}

export default LoginPage
